module.exports = __webpack_public_path__ + "img/6-14_Simulation.f25a9719.png";